module.exports = __webpack_public_path__ + "static/media/img-dentist-product-3@3x.f059aa0f.png";